import React, { useEffect, useRef } from "react";
import Matter from "matter-js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const FooterWithMenu = () => {
    return (
      <>
        <footer className="bg-black text-white py-10 ">
          <div className="max-w-[1600px] mx-auto px-5 grid gap-8 lg:grid-cols-5 sm:grid-cols-1">
            {/* Left Section (Takes 2 columns on large screens) */}
            <div className="text-6xl lg:text-8xl 2xl:text-9xl font-light lg:col-span-2 font-lexend leading-[6rem]">
              Let’s Talk
            </div>

            {/* Center Section (Takes 1 column) */}
            <div>
              <h3 className="text-base leading-5 font-semibold mb-4 font-inter ">
                Quick Links
              </h3>
              <ul className="grid grid-cols-2 gap-y-2 w-[95%]">
                <li>
                  <a
                    href="#"
                    className="hover:underline text-[#fff] opacity-50 font-lexend font-normal text-sm leading-[1.125rem]"
                  >
                    <Link to="/"> Home </Link>
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="hover:underline text-[#fff] opacity-50 font-lexend font-normal text-sm leading-[1.125rem]"
                  >
                    <Link to="/about">About Us</Link>
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="hover:underline text-[#fff] opacity-50 font-lexend font-normal text-sm leading-[1.125rem]"
                  >
                    <Link to="/works"> Our works</Link>
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="hover:underline text-[#fff] opacity-50 font-lexend font-normal text-sm leading-[1.125rem]"
                  >
                    <Link to="/services"> Our Services </Link>
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="hover:underline text-[#fff] opacity-50 font-lexend font-normal text-sm leading-[1.125rem]"
                  >
                    <Link to="/contact">Contact</Link>
                  </a>
                </li>
              </ul>
            </div>
            {/* socials */}
            <div className="w-[80%]">
              <h3 className="text-base leading-5 font-semibold mb-4 font-inter">
                Social Links
              </h3>
              <ul className="grid grid-cols-2 gap-y-2 ">
                <li>
                  <a
                    href="https://wa.me/918122879321"
                    className="hover:underline text-[#fff] opacity-50 font-lexend font-normal text-sm leading-[1.125rem]"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Whatsapp
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/hana_toria"
                    className="hover:underline text-[#fff] opacity-50 font-lexend font-normal text-sm leading-[1.125rem]"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Instagram
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/profile.php?id=100089837880458"
                    className="hover:underline text-[#fff] opacity-50 font-lexend font-normal text-sm leading-[1.125rem]"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Facebook
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/89910172/admin/dashboard/"
                    className="hover:underline text-[#fff] opacity-50 font-lexend font-normal text-sm leading-[1.125rem]"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    LinkedIn
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.behance.net/hanator-ades"
                    className="hover:underline text-[#fff] opacity-50 font-lexend font-normal text-sm leading-[1.125rem]"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Behance
                  </a>
                </li>
              </ul>
            </div>

            {/* Right Section (Takes 1 column) */}
            <div>
              <h3 className="text-base leading-5 font-semibold mb-4 font-inter">
                Our Office
              </h3>
              <p className="mb-2 font-lexend opacity-50 font-semibold text-base leading-[1.125rem] ">
                India
              </p>
              <p className="mb-2 font-lexend font-normal text-sm leading-5 ">
                747-G, 2nd floor, TSJ Complex,
                <br /> Near Anna Statue, Avinashi road,
                <br /> Coimbatore – 641018
              </p>
              <div className="flex flex-col gap-2">
                <p className="flex items-center gap-2 ">
                  <FontAwesomeIcon
                    icon={faEnvelope}
                    className="text-[#F15A28]"
                  />
                  <a
                    href="mailto:projects@hanatoria.com"
                    className="hover:underline font-lexend opacity-50 font-normal text-xs leading-[1.125rem] "
                  >
                    projects@hanatoria.com
                  </a>
                </p>
                <p className="flex items-center gap-2">
                  <FontAwesomeIcon icon={faPhone} className="text-[#F15A28]" />
                  <a
                    href="tel:+918122879321"
                    className="hover:underline font-lexend opacity-50 font-normal text-xs leading-[1.125rem]"
                  >
                    +91 8122879321
                  </a>
                </p>
              </div>
              {/* <Link
              to="/company-policies"
              className="text-sm text-gray-600 hover:text-black"
            >
              Company Policies
            </Link> */}
            </div>
          </div>
          <div className="mt-8 border-t border-white border-opacity-20 pt-6 text-center text-xs font-lexend text-white opacity-50">
            <p>© 2025 hanatoria.com All rights reserved.</p>
            <p>
              Crafted by <a href="https://senthurontech.com/">Senthuron tech</a>
            </p>
            <p>
              <Link to="/company-policies" className="underline text-white">
                Company Policies
              </Link>{" "}
              | All disputes are subject to the jurisdiction of courts in
              Coimbatore, Tamil Nadu.
            </p>
          </div>
        </footer>
      </>
    );
};

export default FooterWithMenu;